import React, { useState, useEffect } from "react";
// import { withTranslation } from "react-i18next";
import { BiFile } from "react-icons/bi";
import { CiUser } from "react-icons/ci";
import { BsBank, BsJournalCheck, BsBook, BsGraphUpArrow, BsArrowRight } from "react-icons/bs";
import { PiGraduationCapLight } from "react-icons/pi";
import { GiPencil } from "react-icons/gi";
import { LiaClipboardListSolid } from "react-icons/lia";

import "./cours-details.css";

export function CoursDetails(props) {
  const { t } = props;

  const audience = [
    {
      icon: <PiGraduationCapLight />,
      title: "Redação",
      subtitle: "ENEM",
    },
    {
      icon: <BiFile />,
      title: "Redação para",
      subtitle: "Concursos",
    },
    {
      icon: <BsBank />,
      title: "Produção textual",
      subtitle: "para Vestibulares",
    },
    {
      icon: <BsJournalCheck />,
      title: "Correção de Redações",
      subtitle: "Feedback Individual",
    },
    {
      icon: <CiUser />,
      title: "Mentorias",
      subtitle: "Individuais",
    },
  ];

  const benefits = [
    {
      icon: <BsBook />,
      title: "1. Aprenda",
      text: "Aulas online objetivas e materiais completos para dominar a escrita.",
    },
    {
      icon: <GiPencil />,
      title: "2. Escreva",
      text: "Pratique com propostas de redação e atividades direcionadas.",
    },
    {
      icon: <LiaClipboardListSolid />,
      title: "3. Receba feedback",
      text: "Correções detalhadas com feedback individual e orientações claras.",
    },
    {
      icon: <BsGraphUpArrow />,
      title: "4. Evolua",
      text: "Aplique as correções, acompanhe seu progresso e conquiste seus objetivos.",
    },
  ];

  function SectionHeading({ title, subtitle, light = false }) {
    return (
      <div
        className={`section-heading ${light ? "section-heading-light" : ""}`}>
        <h2>{title}</h2>
        <span className="heading-line" />
        {subtitle && <p>{subtitle}</p>}
      </div>
    );
  }

  return (
    <>
      {/* <main> */}
      {/* PARA QUEM */}
      <section className="audience-section">
        <div className="container">
          <SectionHeading title="Para quem é o Escrita Prática?" light />

          <div className="row g-4 justify-content-center">
            {audience.map((item) => (
              <div
                className="col-6 col-md-4 col-lg"
                key={item.title + item.subtitle}
              >
                <div className="audience-item">
                  <div className="icon-ep-brand-light">{item.icon}</div>
                  <strong>{item.title}</strong>
                  <span>{item.subtitle}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DETAILS HOW IT WORKS */}
      <section id="como-funciona" className="how-section">
        <div className="container">
          <SectionHeading
            title="Como funciona"
            subtitle="Um passo a passo simples para você evoluir na escrita."
          />

          <div className="steps-wrapper">
            {benefits.map((item, index) => (
              <React.Fragment key={item.title}>
                <div className="step step-item">
                  <div className="icon-ep-brand step-icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>

                {index < benefits.length - 1 && (
                  <div className="step-arrow"> <BsArrowRight  /></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>
      {/* </main> */}
    </>
  );
}

// export default withTranslation()(CoursDetails);
export default CoursDetails;